import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchMacroSummary } from '../../../services/decisionApi';
import { formatMacroPct, macroChangeClass } from './macroFormat';

const REFRESH_MS = 5 * 60 * 1000;

export default function MacroStrip() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let timer;

    async function load() {
      try {
        const summary = await fetchMacroSummary();
        if (!cancelled) setData(summary);
      } catch {
        if (!cancelled) setData(null);
      }
    }

    load();
    timer = setInterval(load, REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  const items = data?.strip_items || [];

  if (!items.length) return null;

  return (
    <div className="macro-strip">
      {items.map((item) => {
        if (item.type === 'bond_weather') {
          return (
            <Link
              key="bond-weather"
              to={`/macro?tab=${item.tab || 'bond'}`}
              className="macro-strip-item bond"
            >
              <span className="macro-strip-label">{item.label}</span>
              <span>
                {item.weather_emoji} {item.weather_label}
                {item.trade_date ? ` · ${item.trade_date}` : ''}
              </span>
            </Link>
          );
        }
        return (
          <Link
            key={item.code}
            to={`/macro?tab=${item.tab || 'equity'}`}
            className={`macro-strip-item ${macroChangeClass(item.change_pct)}`}
          >
            <span className="macro-strip-label">{item.name}</span>
            <span>{formatMacroPct(item.change_pct)}</span>
          </Link>
        );
      })}
    </div>
  );
}
